import React from "react";

// Branded loader: the optimized boat illustration + the wordmark (Plus Jakarta
// Sans, matching the masthead) + a slim gold progress bar, on the cream
// background. Token fallbacks keep it correct even on the very first paint.
export default function SailingLoader() {
  const base = (typeof process !== "undefined" && process.env && process.env.PUBLIC_URL) || "";
  const red = "var(--race-red, #E04A4A)";
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--bg, #F4F1EA)", overflow: "hidden", padding: 24, gap: 24 }}>
      <style>{`
        @keyframes pmf-fade { from { opacity:0; transform: translateY(8px); } to { opacity:1; transform:none; } }
        @keyframes pmf-slide { 0% { margin-left:-45%; } 100% { margin-left:120%; } }
        @keyframes pmf-bob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
      `}</style>

      <img
        src={base + "/pmf-loader-boat.webp"}
        onError={(e) => { if (!e.currentTarget.dataset.f) { e.currentTarget.dataset.f = "1"; e.currentTarget.src = base + "/pmf-loader-boat.png"; } }}
        alt="Pardon My French"
        style={{ width: 150, maxWidth: "44vw", height: "auto", filter: "drop-shadow(0 8px 22px rgba(11,22,38,0.12))", animation: "pmf-fade 0.6s ease-out, pmf-bob 3.2s ease-in-out infinite" }}
      />

      <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, letterSpacing: "-0.02em", fontSize: 22, color: "var(--text, #0B1626)", lineHeight: 1, animation: "pmf-fade 0.6s ease-out 0.1s both" }}>
        Pardon My French<span style={{ fontWeight: 800, fontSize: "0.4em", color: red, verticalAlign: "super", marginLeft: "0.05em" }}>Racing</span>
        <span aria-hidden="true" style={{ display: "inline-flex", flexDirection: "column", gap: 2, marginLeft: 7, verticalAlign: "middle" }}>
          <span style={{ height: 2, width: 16, background: red, borderRadius: 2 }} />
          <span style={{ height: 2, width: 11, background: red, borderRadius: 2, opacity: 0.7 }} />
          <span style={{ height: 2, width: 7, background: red, borderRadius: 2, opacity: 0.45 }} />
        </span>
      </div>

      <div style={{ width: 120, height: 3, background: "var(--border, #D5CCBA)", borderRadius: 99, overflow: "hidden", animation: "pmf-fade 0.6s ease-out 0.2s both" }}>
        <div style={{ height: "100%", width: "40%", background: "var(--gold, #B8860B)", borderRadius: 99, animation: "pmf-slide 1.3s ease-in-out infinite" }} />
      </div>
    </div>
  );
}
